// extracted by mini-css-extract-plugin
export var errorsContainer = "_px-1";
export var link = "_px-0";